//import $ from 'jquery';
import Param from '../../helpers/Param';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import config from '../../config/config';
import {searchService} from './search';

export const catalogMailingListsService = {
	getCatalogMailingLists,
	getCatalogMailingListDetails,
	getCatalogMailingListsByRecipient,
	getCatalogMailingListRecipients,
	addCatalogMailingList,
	editCatalogMailingList,
	deleteCatalogMailingList,
	addRecipient,
	deleteRecipient,
	resendInvitation
};

function getCatalogMailingLists(params, globalFilter){
	return true || config.live ? getCatalogMailingListsLive(params, globalFilter) : getCatalogMailingListsStatic();
}

function getCatalogMailingListsLive(params, globalFilter) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/source_sql_mailing_lists`;
	return fetch(baseUrl, {
		method: 'GET',
		headers
	})
	.then(res=>{   
		return res.json()
	})
	
}

function getCatalogMailingListsStatic(params) {
	let baseUrl = `${config.apis.sales}/api/static/source_sql_mailing_lists.json`;
	return fetch(baseUrl, {
		method: 'GET'
	})
	.then(res=>{   
		return res.json()
	})
}



function getCatalogMailingListDetails(id){
	return true || config.live ? getCatalogMailingListDetailsLive(id) : getCatalogMailingListDetailsStatic();
}

function getCatalogMailingListDetailsLive(id) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/source_sql_mailing_lists/${id}`;
	return fetch(baseUrl, {
		method: 'GET',
		headers
	})
	.then(res=>{   
		return res.json()
	})
	
}

function getCatalogMailingListDetailsStatic(params) {
	let baseUrl = `${config.apis.sales}/api/static/catalogMailing_list.json`;
	return fetch(baseUrl, {
		method: 'GET'
	})
	.then(res=>{   
		return res.json()
	})
}


function getCatalogMailingListRecipients(id){
	return true || config.live ? getCatalogMailingListRecipientsLive(id) : getCatalogMailingListRecipientsStatic();
}

function getCatalogMailingListRecipientsLive(id) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/source_sql_mailing_lists/${id}/recipients`;
	return fetch(baseUrl, {
		method: 'GET',
		headers
	})
	.then(res=>{   
		return res.json()
	})
	
}

function getCatalogMailingListRecipientsStatic(params) {
	let baseUrl = `${config.apis.sales}/api/static/catalogMailing_list_recipients.json`;
	return fetch(baseUrl, {
		method: 'GET'
	})
	.then(res=>{   
		return res.json()
	})
}


function addCatalogMailingList(data) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/source_sql_mailing_lists`;
	return fetch(baseUrl, {
		method: 'POST',
		headers,
		body: JSON.stringify(data)
	})
	.then(res=>{   
		return res.json()
	})
	
}

function editCatalogMailingList(data, id) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/source_sql_mailing_lists/${id}`;
	return fetch(baseUrl, {
		method: 'PUT',
		headers,
		body: JSON.stringify(data)
	})
	.then(res=>{   
		return res.json()
	})
	
}

function deleteCatalogMailingList(id) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/source_sql_mailing_lists/${id}`;
	return fetch(baseUrl, {
		method: 'DELETE',
		headers
	})
	.then(res=>{   
		return res.json()
	})
	
}

function addRecipient(email, mailingListID) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/mailing_list_recipients`;
	return fetch(baseUrl, {
		method: 'POST',
		headers,
		body: JSON.stringify({mailing_list_id: mailingListID, email})
	})
	.then(res=>{   
		return res.json()
	})
	
}

function deleteRecipient(id, mailingListID) {
	let baseUrl = `${config.apis.orthus}/v1/mailing_list_recipients/${id}?mailing_list_id=${mailingListID}`;
	return fetch(baseUrl, {
		method: 'DELETE',
		headers: AuthHeader()
	})
	.then(res=>{   
		return res.json()
	});
}

function getCatalogMailingListsByRecipient(id){
	return true || config.live ? getCatalogMailingListsByRecipientLive(id) : getCatalogMailingListsByRecipientStatic();
}

function getCatalogMailingListsByRecipientLive(id) {
	let headers = AuthHeader({'Content-Type': 'application/json'}),
		baseUrl = `${config.apis.orthus}/v1/catalogMailing_list_recipients/my_catalogMailings`;
	return fetch(baseUrl, {
		method: 'GET',
		headers
	})
	.then(res=>{   
		return res.json()
	})
	
}

function getCatalogMailingListsByRecipientStatic(params) {
	let baseUrl = `${config.apis.sales}/api/static/source_sql_mailing_lists_by_recipient.json`;
	return fetch(baseUrl, {
		method: 'GET'
	})
	.then(res=>{   
		return res.json()
	})
}

function resendInvitation(id) {
	let baseUrl = `${config.apis.orthus}/v1/catalogMailing_list_recipients/resent_email?recipient_id=${id}`;
	return fetch(baseUrl, {
		method: 'PATCH',
		headers: AuthHeader()
	})
	.then(res=>{   
		return res.json()
	});
} 